import React, { useState, useEffect } from "react";
import Home from "../../pages/Home";
import Loader from "../../components/Loader/Loader";
import axios from "axios";
import { createLocalDb, insertDataInLocalDb } from "../../store";

const API_PATH="https://brsinbox.com/API/";

export const Launch = (props) => {
  const { isLaunchVal, userId, ownerId, mno } = props;

  const [isLaunch, setLaunchPage] = useState(isLaunchVal);
  const [dbReady, setDbReady] = useState(false);

  /* -------------------- INIT INDEXED DB (ONCE) -------------------- */
  useEffect(() => {
    const initDb = async () => {
      try {
        await createLocalDb(); // ✅ wait
        setDbReady(true);
      } catch (e) {
        console.error("IndexedDB init failed", e);
      }
    };
    initDb();
  }, []);

  /* -------------------- GROUP CONTACTS -------------------- */
/*   const getGroupContacts = (groupId) => {
    const payload = { userId, ownerId, groupId, mno };

    axios.post(API_PATH + "groupContacts.php", payload).then((res) => {
      Object.values(res.data.Content || {}).forEach((item) => {
        if (item?.contactId) {
          insertDataInLocalDb(item, "_groupContacts", item.contactId);
        }
      });
    });
  }; */
 
  /* -------------------- FINAL LAUNCH -------------------- */
  const setIsReadyForLaunch = () => {
    localStorage.setItem("_tm_isLaunch", "N");
    const _tm_isHome_2=localStorage.getItem("_tm_isHome");
	if(_tm_isHome_2 !== "Y"){
		setLaunchPage(false);
		localStorage.setItem("_tm_isHome", "Y");
		window.location.reload();
	}
  };

  /* -------------------- API CALLS -------------------- */
  const apiAxiosCall = () => {
	  
	 // alert('DFG');
    const userData = localStorage.getItem("_tm_userData") || "";
    const isLaunchVal = localStorage.getItem("_tm_isLaunch") || "";

    const isLogin = userData !== "" && userData !== "_lgt";
    const isLaunch = isLaunchVal === "" || isLaunchVal === "Y";
    console.log(isLogin);
    console.log(isLaunch);
    if (!isLogin || !isLaunch) return;

    const payload = { userId, ownerId, campaignType: "41", mno };

    const save = (api, store, key) =>
      axios.post(API_PATH + api, payload).then((res) => {
        Object.values(res.data.Content || {}).forEach((item) => {
          if (item?.[key]) {
            insertDataInLocalDb(item, store, item[key]);
          }
        });
      });

    Promise.all([
      save("hierarchyEmp.php", "_hierarchyEmp", "empId"),
      save("hierarchyRs.php", "_hierarchyRs", "relId"),
      save("getMasters.php", "_ccv1_getMasters", "masterId"),
      save("parentdictionary2.php", "_parentdictionary2", "eId"),
      save("groupsList.php", "_groupsList", "groupId"),
      save("historyApi.php", "_historyApi", "campaignId"),
      save("api/get_all_ads.php", "_adsList", "id"),
      save("chatThreadByUserId.php", "_chatThreadByUserId", "chatId"),
    ]).then(() => {
      setTimeout(setIsReadyForLaunch, 1000);
    });
  };

  /* -------------------- RUN APIs ONLY WHEN DB READY -------------------- */
  useEffect(() => {
    if (!dbReady) return;
    apiAxiosCall();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dbReady]);

  return (
    <section>
      {isLaunch ? <Loader /> : <Home />}
    </section>
  );
};

export default Launch;
